import { Terminal } from "lucide-react";

export function Logo({ size = "md", onClick }) {
  const dim = size === "lg" ? "h-10 w-10" : "h-8 w-8";
  const text = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className={`flex items-center gap-2.5 ${onClick ? "cursor-pointer" : ""}`} onClick={onClick} data-testid="brand-logo">
      <div className={`${dim} rounded-lg bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center dc-glow`}>
        <Terminal className="h-1/2 w-1/2 text-slate-950" strokeWidth={2.5} />
      </div>
      <span className={`${text} font-head font-bold tracking-tight`}>
        D<span className="dc-gradient-text">Code</span>
      </span>
    </div>
  );
}
